import React, { useState } from 'react';
import * as St from '../../AnticipationConference/styles';

import ContainerFlex from '~/components/containerFlex';
import Button from '~/components/button';
import RadioButton from '~/components/radioButton';

type PaymentOptions = 'PIX' | 'CAIXA' | '';
const ConferencePaymentOptions: React.FC<{
  onSubmit: (selected: PaymentOptions) => void;
}> = ({ onSubmit }) => {
  const [selected, setSelected] = useState<PaymentOptions>('');
  const handleChangeSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name as PaymentOptions;
    setSelected(name);
  };
  
  return (
    <St.BoxCard>
      <ContainerFlex space>
        <ContainerFlex marginRight={16} gap="15" marginTop={5}>
          <St.Title>Forma de pagamento</St.Title>
          <St.Info>
            Escolha abaixo qual será a forma de pagamento da antecipação
          </St.Info>
        </ContainerFlex>
        <ContainerFlex row marginTop={5}>
          <ContainerFlex row horizontal align="center">
            <RadioButton
              style={{ border: '1px solid red' }}
              name="PIX"
              onChange={handleChangeSelected}
              checked={selected === 'PIX'}
            />
            <St.Info>Pagamento com PIX</St.Info>
          </ContainerFlex>
          <ContainerFlex end row horizontal align="center">
            <RadioButton
              style={{ border: '1px solid red' }}
              onChange={handleChangeSelected}
              name="CAIXA"
              checked={selected === 'CAIXA'}
            />
            <St.Info>Pagamento no caixa</St.Info>
          </ContainerFlex>
          <ContainerFlex end row padding={16}>
            <Button
              fitContent
              disabled={selected === ''}
              onClick={() => onSubmit(selected)}
            >
              <span>Concluir</span>
            </Button>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
    </St.BoxCard>
  );
};

export default ConferencePaymentOptions;
